import { ThemeConfig } from "antd";
import { merge } from "lodash-es";

import { themeConfig as sharedThemeConfig } from "../shared";

const PALETTE = {
  primary: {
    main: "#F16622",
    hover: "#DE4F18",
  },
  custom: {
    lightGrey: "#EEEEEE",
    extraLightGrey: "#D9D9D9",
    mediumGrey: "#757575",
    darkGrey: "#24242D",
    white: "#FFFFFF",
    black: "#000000",
    mediumGreen: "#00861D",
    blue: "#006EF3",
  },
};

export const ESR_COLORS = {
  optionCard: {
    selectedBg: "#fff6f0",
    hoverBg: "#f7f7f7",
    hoverSelectedBg: "#ffeadd",
    radioDot: PALETTE.primary.hover,
  },
} as const;

export const esrTheme: ThemeConfig = {
  token: {
    borderRadius: 4,
    colorPrimary: PALETTE.primary.main,
    colorTextSecondary: PALETTE.custom.darkGrey,
    colorTextPlaceholder: PALETTE.custom.mediumGrey,
    fontFamily: "Trade Gothic Next LT Pro, arial, sans-serif",
    fontFamilyCode: "Trade Gothic Next LT Pro, arial, sans-serif",
    boxShadow: "0px 8px 15px 0px rgba(0, 0, 0, 0.10)",
    colorTextTertiary: PALETTE.custom.mediumGrey,
    colorLink: "#AD4702",
  },
  components: {
    Button: {
      colorPrimary: PALETTE.primary.main,
      colorPrimaryHover: PALETTE.primary.hover,
      colorLink: PALETTE.primary.main,
      colorLinkHover: PALETTE.primary.hover,
      linkDecoration: "underline",
      fontSize: 12,
      fontSizeLG: 12,
    },
    Input: {
      colorBorder: PALETTE.custom.mediumGrey,
      borderRadius: 4,
      hoverBorderColor: PALETTE.custom.darkGrey,
      activeBorderColor: PALETTE.custom.darkGrey,
    },
    Select: {
      colorBorder: PALETTE.custom.mediumGrey,
      borderRadius: 4,
      optionPadding: "8px 16px",
    },
    InputNumber: {
      borderRadius: 4,
      addonBg: PALETTE.custom.darkGrey,
      colorBorder: PALETTE.custom.mediumGrey,
      hoverBorderColor: PALETTE.custom.darkGrey,
      activeBorderColor: PALETTE.custom.darkGrey,
    },
    Typography: {
      fontSizeHeading3: 20,
      lineHeightHeading3: 1.3,
    },
    Steps: {
      colorSplit: PALETTE.custom.extraLightGrey,
      controlItemBgActive: PALETTE.custom.mediumGreen,
      colorText: PALETTE.custom.darkGrey,
      colorPrimary: PALETTE.custom.darkGrey,
      fontSize: 16,
    },
    Slider: {
      handleColor: PALETTE.custom.darkGrey,
      trackBg: PALETTE.custom.darkGrey,
      trackHoverBg: PALETTE.custom.darkGrey,
      handleActiveColor: PALETTE.custom.darkGrey,
    },
    Progress: {},
  },
};

export const themeConfig: ThemeConfig = merge({}, sharedThemeConfig, esrTheme);
